<template>
  <!-- htmlファイル側の「<router-view>」内に表示する内容 -->
    <nav>
      <div class="d-grid gap-3 vy-right-nav" >
        <span v-on:click="home()" class="btn btn-primary vy-btn-primary vy-right-nav-btn shadow">HOME</span>
        <span v-on:click="import_csv()" class="btn btn-primary vy-btn-primary vy-right-nav-btn shadow">インポート</span>
        <span v-on:click="jizen()"  class="btn btn-primary vy-btn-primary vy-right-nav-btn shadow">事前研修情報</span>
        <span v-on:click="jigo()"  class="btn btn-primary vy-btn-primary vy-right-nav-btn shadow">事後集会情報</span>
        <span v-on:click="taiken()"  class="btn btn-primary vy-btn-primary vy-right-nav-btn shadow">体験プログラム情報</span>
        <span v-on:click="user()"  class="btn btn-primary vy-btn-primary vy-right-nav-btn shadow">
            <span v-if="cancel == 1 || message == 1" style="color:red"><b>体験ユーザー管理</b></span>
            <span v-else>体験ユーザー管理</span>
        </span>
        
        <span v-on:click="mail()" class="btn btn-primary vy-btn-primary vy-right-nav-btn shadow" style="background-color: green;">メール情報</span>
        <span v-on:click="form()"  class="btn btn-primary vy-btn-primary vy-right-nav-btn shadow" style="background-color: green;">アンケート・報告書情報</span>
        <span v-on:click="shomei()" class="btn btn-primary vy-btn-primary vy-right-nav-btn shadow" style="background-color: green;">参加証明書情報</span>
        <br>
        <span v-on:click="open_taikensha()" class="btn btn-primary vy-btn-primary vy-right-nav-btn shadow" style="background-color: orangered;">体験者用システム情報</span>
        <br><!--
        <p v-if="GlobalData.$ID_Token.headers.Authorization == ''" v-on:click="login" style="cursor:pointer">ログイン</p>
        <p v-else style="padding: 10px; margin-bottom: 10px; border: 5px double rgb(51, 51, 51); border-radius: 10px; background-color: cyan;">ログイン中</p>-->
        <p v-on:click="log_out" style="cursor:pointer"><u>ログアウト</u></p>


        <p v-on:click="Return_kanri" style="cursor:pointer" v-if="kengen == 'master' || kengen == 'Master'">
            <!-- マスターアカウントのみ表示 -->
            <u>さんこう株式会社<br>管理画面</u>
        </p>
      </div>
    </nav>
</template>

<style scoped>

button{
  padding: 0;
}

</style>

<script setup>
/* eslint-disable */
import {
    CognitoUserPool,
    CognitoUser,
    AuthenticationDetails } from 'amazon-cognito-identity-js'
import { useRouter,useRoute } from 'vue-router'
import { GlobalData, login_check } from '../js/userdata_shakyo.js'
import { ref } from 'vue'

import axios from 'axios'
login_check()


let route = useRoute()
// アカウントの権限
let kengen = ref("")

  
let cancel = ref(0)
let message = ref(0)

/* 変数の記述 */
let router = useRouter()

const login = function() {
    //document.getElementById("vy_responsive_menu_close").click();
	login_check()
    router.push('/'+GlobalData.shakyo+'/Kanri/MailLogin')
}
const log_out = function() {
    let poolData = {
        UserPoolId: GlobalData.$UserPoolId,  // Your user pool id here
        ClientId: GlobalData.$ClientId  // Your client id here
    };
    const userPool = new CognitoUserPool(poolData);
    let cognitoUser = userPool.getCurrentUser();
    if (cognitoUser) {
        // ログアウト
        cognitoUser.signOut();
        GlobalData.$User_email = "";
        //alert("ログアウトしました。");
    }
    GlobalData.$User_email = null
    GlobalData.user_id = null
    GlobalData.kencd = null
    GlobalData.city = null
    GlobalData.kengen = null
    //document.getElementById("vy_responsive_menu_close").click();
    router.push('/'+GlobalData.shakyo+'/Kanri/MailLogin')
}

let logout = function() {
    let poolData = {
        UserPoolId: GlobalData.$UserPoolId,  // Your user pool id here
        ClientId: GlobalData.$ClientId  // Your client id here
    };
    const userPool = new CognitoUserPool(poolData);
    let cognitoUser = userPool.getCurrentUser();
    if (cognitoUser) {
        // ログアウト
        cognitoUser.signOut();
        GlobalData.$User_email = "";
        //alert("ログアウトしました。");
    }
    GlobalData.$User_email = null
    GlobalData.user_id = null
    GlobalData.kencd = null
    GlobalData.city = null
    GlobalData.kengen = null
    router.push('/'+GlobalData.shakyo+'/Kanri/MailLogin')

}


const emit = defineEmits(['form_reset']);

let home = function(){
    search_param_reset()
    router.push('/'+GlobalData.shakyo+'/Kanri')
}
let import_csv = function(){
    search_param_reset()
    
    router.push('/'+GlobalData.shakyo+'/Kanri/CSV')
}
let jizen = function(){
    search_param_reset()
    
    router.push('/'+GlobalData.shakyo+'/Kanri/Jizen/list')
}
let taiken = function(){
    search_param_reset()
    
    router.push('/'+GlobalData.shakyo+'/Kanri/Taiken/list')
}

let jigo = function(){
    search_param_reset()
    
    router.push('/'+GlobalData.shakyo+'/Kanri/Jigo/list')
}
let user = function(){
    search_param_reset()
    
    router.push('/'+GlobalData.shakyo+'/Kanri/User/list')
}

let mail = function(){
    search_param_reset()
    router.push('/'+GlobalData.shakyo+'/Kanri/Mail/list')

}

let shomei = function(){
    search_param_reset()
    
    router.push('/'+GlobalData.shakyo+'/Kanri/Shomei/list')
}

let system = function(){
    search_param_reset()
    
    router.push('/'+GlobalData.shakyo+'/Kanri/System')
}

let form = function(){
    search_param_reset()
    
    router.push('/'+GlobalData.shakyo+'/Kanri/Form/list')
}


let Return_moshikomi = function(){
    
    // ログアウト
    var poolData = {
        UserPoolId : GlobalData.$UserPoolId,
        ClientId : GlobalData.$ClientId
    };
    var userPool = new CognitoUserPool(poolData);
    var cognitoUser = userPool.getCurrentUser();
    if (cognitoUser) {
        // ログアウト
        cognitoUser.signOut();
    }
    
    GlobalData.$User_email = null
    GlobalData.user_id = null
    GlobalData.kencd = null
    GlobalData.city = null
    GlobalData.kengen = null
    
    search_param_reset()
    
    router.push('/'+GlobalData.shakyo+'/Taiken')
}

let Return_kanri = function(){
    router.push('/Sanko')
}

let open_taikensha = function(){
   
    emit('call',{cmd:'open_taikensha'});
}


let rireki_check_count = 0
let rireki_check = function(){
    let send_array = {"choson_code":GlobalData.choson_code,"cancel":"0"}
  //---------------- 操作履歴を取得
  axios.post(GlobalData.$API_URL+"Rireki_get", send_array,GlobalData.$ID_Token
          ).then(response => {
            if(response.data.rireki_kanri.length != 0){
                cancel.value = 1
            }
  }).catch(error => {
    if(rireki_check_count == 6){
        alert("キャンセル・削除履歴の取得時にエラーが発生しました。"+error)
    }else{
        rireki_check_count++
        setTimeout(function(){rireki_check()},"1000")
    }
  })
}

let message_check_count = 0
let message_check = function(){
    let send_array = {"choson_code":GlobalData.choson_code,"kubun":8,"rireki_check":0}
  //---------------- 操作履歴を取得
  axios.post(GlobalData.$API_URL+"Rireki_get", send_array,GlobalData.$ID_Token
          ).then(response => {
            if(response.data.rireki_kanri.length != 0){
                message.value = 1
            }
  }).catch(error => {
    
    if(message_check_count == 6){
        alert("未読メッセージの取得時にエラーが発生しました。"+error)
    }else{
        message_check_count++
        setTimeout(function(){rireki_check()},"1000")
    }
  })
}



import { useStore } from 'vuex'
const store = useStore()
// 検索条件の初期化
let search_param_reset = function(){
    store.state.taikenuser = {}
}


setTimeout(function(){
    kengen.value = GlobalData.kengen
    rireki_check()
    message_check()
},"1000")


</script>


<style scoped>
.btn-default >.badge-notify{
   background:red;
   position:relative;
   top: 7px;
   left: -62px;
}
</style>